module.exports = __webpack_public_path__ + "assets/img/bg.ee13a477.png";